import { useState, useEffect } from "react";
import { getSavedFilters } from "../views/lib/HOC/withFilters";

const defaultStates = {
  name: "",
  page: 0,
  size: 10,
  sort: "id,asc",
  filters: [],
  callback: () => {
  },
  setLoading: () => {
  },
};

const useSearchHook = (searchFunction, initialStates = defaultStates) => {
  initialStates = {
    ...defaultStates,
    ...initialStates
  };
  const [page, setPage] = useState(initialStates.page);
  const [size, setSize] = useState(initialStates.size);
  const [sort, setSort] = useState(initialStates.sort);
  const [filters, setFilters] = useState(initialStates.filters.length ? initialStates.filters : getSavedFilters(initialStates.name));

  const handleSearch = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
  };

  const handleReset = () => {
    handleSearch([]);
  };

  const handleSortedChange = (sorted) => {
    const key = sorted[0].id;
    const newSort = `${key},${sorted[0].desc ? "desc" : "asc"}`;
    setSort(newSort);
  };

  useEffect(() => {
    searchFunction(page, size, sort, filters, initialStates.callback, initialStates.setLoading);
  }, [searchFunction, page, size, sort, filters, initialStates.callback, initialStates.setLoading]);

  return {
    page,
    size,
    sort,
    filters,
    handleSearch,
    handleReset,
    handlePageChange: setPage,
    handleSortedChange,
    handlePageSizeChange: setSize
  };
};

export default useSearchHook;



// WEBPACK FOOTER //
// ./src/hooks/useSearch.hook.js